import { APIURL } from "../config/app-globals.enum";
import { getToken } from "./LocalStorageService";
import PraisoServices from "./PraisoServices";

export const getAdminMileageClaimList = async (claimStatusId?: number) => {
    let ApiUrl = `${APIURL.GET_ADMIN_MILEAGE_CLAIM}`;
    const token = getToken();
    try {
        const response = await PraisoServices(ApiUrl, "get", {}, { "claimStatusId": claimStatusId }, { Authorization: `Bearer ${token}`, });
        try {
            return response;
        } catch (error) {
            const err = error as Error;
            return {
                status: {
                    code: 1,
                    message: err?.message,
                },
                content: null,
            };
        }
    } catch (error_1) {
        const err = error_1 as Error;
        return {
            status: {
                code: 1,
                message: err.message,
            },
            content: null,
        };
    }
};

export const approveRejectMileageClaim = async (request: any, id: number) => {
    let ApiUrl = `${APIURL.UPDATE_MILEAGE_CLAIM}/${id}`;
    const token = getToken();
    try {
        const response = await PraisoServices(ApiUrl, "patch", { ...request }, {}, { Authorization: `Bearer ${token}`, });
        try {
            return response;
        } catch (error) {
            const err = error as Error;
            return {
                status: {
                    code: 1,
                    message: err?.message,
                },
                content: null,
            };
        }
    } catch (error_1) {
        const err = error_1 as Error;
        return {
            status: {
                code: 1,
                message: err.message,
            },
            content: null,
        };
    }
};

export const getMileageClaimDetails = async (userId: number, mileageClaimId: number) => {
    let ApiUrl = `${APIURL.GET_MILEAGE_CLAIM_DETAILS}/${userId}/${mileageClaimId}`;
    const token = getToken();
    try {
        const response = await PraisoServices(ApiUrl, "get", {}, null, { Authorization: `Bearer ${token}`, });
        try {
            return response;
        } catch (error) {
            const err = error as Error;
            return {
                status: {
                    code: 1,
                    message: err?.message,
                },
                content: null,
            };
        }
    } catch (error_1) {
        const err = error_1 as Error;
        return {
            status: {
                code: 1,
                message: err.message,
            },
            content: null,
        };
    }
};

export const GetDriverTripListForMileageClaim = async (params) => {
    let url = APIURL.TRIP_LIST_API + params.userId;
    const token = getToken();
    try {
        const response = await PraisoServices(
            url,
            "get",
            {},
            { ...params },
            {
                Authorization: `Bearer ${token}`
            }
        );
        try {
            return response;
        } catch (error) {
            const err = error as Error;
            return {
                status: {
                    code: 1,
                    message: err?.message,
                },
                content: null,
            };
        }
    } catch (error_1) {
        const err = error_1 as Error;
        return {
            status: {
                code: 1,
                message: err.message,
            },
            content: null,
        };
    }
};

export const GetMileageClaimTripDistanceAPI = async (fromDate: Date, toDate: Date) => {
    let ApiUrl = `${APIURL.GET_MILEAGE_CLAIM_DISTANCE}?`;
    const token = getToken();
    try {
        if (fromDate) {
            ApiUrl += `fromDate=${fromDate.toISOString()}&`;
        }
        if (toDate) {
            ApiUrl += `toDate=${toDate.toISOString()}`;
        }
        const response = await PraisoServices(ApiUrl, "get", {}, null, { Authorization: `Bearer ${token}`, });
        try {
            return response;
        } catch (error) {
            const err = error as Error;
            return {
                status: {
                    code: 1,
                    message: err?.message,
                },
                content: null,
            };
        }
    } catch (error_1) {
        console.warn(error_1);
        const err = error_1 as Error;
        return {
            status: {
                code: 1,
                message: err.message,
            },
            content: null,
        };
    }
};

export const CreateMileageClaimAPI = async (params) => {
    let ApiUrl = `${APIURL.CREATE_MILEAGE_CLAIM}?`;
    const token = getToken();
    try {
        const response = await PraisoServices(ApiUrl, "post", { ...params }, null, { Authorization: `Bearer ${token}`, });
        try {
            return response;
        } catch (error) {
            const err = error as Error;
            return {
                status: {
                    code: 1,
                    message: err?.message,
                },
                content: null,
            };
        }
    } catch (error_1) {
        console.warn(error_1);
        const err = error_1 as Error;
        return {
            status: {
                code: 1,
                message: err.message,
            },
            content: null,
        };
    }
};